<template>
    <nav class="d-print-none">
        <ol class="breadcrumb">
            <template v-for="(item, i) in items">
                <li class="breadcrumb-item">
                    <template v-if="i === items.length - 1">
                        {{ item.label }}
                    </template>
                    <template v-else-if="item.url">
                        <a :href="item.url" style="max-width: none">
                            {{ item.label }}
                        </a>
                    </template>
                    <template v-else>
                        <router-link :to="item.route" custom v-slot="{ href, navigate }">
                            <a :href="href" style="max-width: none" @click="navigate">
                                {{ item.label }}
                            </a>
                        </router-link>
                    </template>
                </li>
            </template>
        </ol>
    </nav>
</template>

<script>
    export default {
        props: {
            items: Array,
        }
    }
</script>
